import { GatewayMode, GatewayOperationalMode } from '../shared/gateway-inventory/gateway-inventory';

export interface GatewayStatus {
    availableMemoryMByte: number;
    gatewayWorkingSetMByte: number;
    totalCpuUtilizationPercent: number;
    gatewayCpuUtilizationPercent: number;
    gatewayVersion: string;
    gatewayDisplayVersion: string;
    friendlyOsName: string;
    installedDate: string;
    logicalProcessorCount: number;
    name: string;
    machineName: string;
    fullyQualifiedDNSName: string;
    addressList: string[];
    gatewayMode: GatewayMode;
    allowedHostOrigins: string[];
    isGatewayProcessElevated: boolean;
    isAadAuthEnabled: boolean;
    isAzureAppCreated: boolean;
    gatewayOperationalMode: GatewayOperationalMode;
    jwk: any;
    installationType?: string;
}
